interface HitPointControls {
    current: HTMLInputElement;
    minus: HTMLButtonElement;
    plus: HTMLButtonElement;
}
